import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import apiParticipantes from "../api/Participantes/api-participantes";
import { RootState } from "../redux/reducers";
import {
  participanteModel,
  participanteModelInitialValues,
} from "../models/ParticipantesModel/participantes.model";
import { useNavigate } from "react-router";
import { openNotification } from "../utils/saveFile";
import moment from "moment";
import { guardarDatosPostulacion } from "../redux/actions/participantesAction";
import getStorageUser from "../middlewares/GetStorageUser";
import { useEncrypt } from "./useEncrypt";
import { ObjNotificaciones } from "../config/notificaciones";
import { consolidateIdentificate } from "../utils/dataSelectOptions";

export const usePersonaNatural = () => {
  const participante = useSelector((state: RootState) => state.participantes);
  const { decrypt, encrypt } = useEncrypt();
  const dispatch = useDispatch();
  const [infoparticipante, setInforParticipante] = useState<participanteModel>(
    participanteModelInitialValues
  );
  const navigate = useNavigate();
  const [imageSelected, setImageSelected] = useState("");
  const [loading, setLoading] = useState(false);

  const cargarInformacionParticipante = async () => {
    if (localStorage.user) {
      let _user = getStorageUser()

      const user = _user;
      // let { user } = await apiRolesPermisos.getUser(localStorage.token);
      let { data } = await apiParticipantes.consultarParticipante(
        user.documento
      );

      if (data.length > 0) {
        if (data.path_foto !== "") {
          const imagen = await apiParticipantes.obtenerArchivo(data.path_foto);
          setImageSelected(URL.createObjectURL(imagen));
        }
        // return setInforParticipante({
        //   ...data,
        //   barrio: data.barrio,
        //   fecha_nacimiento: ,
        // });
      }

      let typeDocConsolidate = consolidateIdentificate.filter((x) => x.value === user.tipo_identificacion);

      // let tipoDoc = user.tipo_identificacion.substring(0, 1) == 1 ? "CC" : "";

      let tipoDoc = typeDocConsolidate.length > 0 ? typeDocConsolidate[0].target : 'CC';

      return setInforParticipante({
        ...infoparticipante,
        primer_nombre: user.nombres,
        primer_apellido: user.apellidos,
        tipo_identificacion: tipoDoc,
        numero_documento: user.documento,
        fecha_nacimiento: data.fecha_nacimiento ? moment(data.fecha_nacimiento) : '', /*user.fecha_nacimiento,*/
        etnia: data.etnia,
        sexo: data.sexo,
        orientacion: data?.orientacion,
        identidad: data?.identidad,
        telefono_celular: data.telefono_celular,
        direccion_residencia: data.direccion_residencia,
        pais_nacimiento: data.pais_nacimiento,
        pais_residencia: data.pais_residencia,
        departamento_nombre: null,
        municipio_nombre: null,
        comuna: null,
        barrio_nombre: null,
        estrato: data.estrato,
        correo_electronico: data.correo_electronico,
        datos_empresa: data.datos_empresa && data.datos_empresa !== null ? data.datos_empresa : { nit: "", razon_social: "", direccion_empresa: "" }
      });
    } else {
      navigate("/login");
    }

    // if (!Array.isArray(data)) {
    // data.fecha_nacimiento = data.fecha_nacimiento = "";
    // return setInforParticipante(data);
    // }
  };
  const guardarInformacionParticipante = async (guardar?: boolean) => {
    const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));

    if (!infoparticipante.politicas)
      return openNotification({
        titulo: "Error",
        descripcion: "Falta aceptar las politicas de uso",
        placement: "bottomRight",
      });

    if (
      parseInt(moment(infoparticipante.fecha_nacimiento).format("YYYYMMDD")) >
      parseInt(moment().format("YYYYMMDD"))
    ) {
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha seleccionada es mayor a la actual",
        placement: "bottomRight",
      });
    }
    setLoading(true);
    const user = getStorageUser()
    let { data } = await apiParticipantes.consultarParticipante(user.documento);
    if (!Array.isArray(data)) {

      infoparticipante.tipo_participante = 1;

      let datamodif = await apiParticipantes.modificarParticipante(
        user.documento,
        infoparticipante
      );
      dispatch(
        guardarDatosPostulacion({
          ...participante.datos_postulacion,
          infoparticipante,
        })
      );
      setLoading(false);

      if (guardar) {
        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
        ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
        return navigate("/Usuario");
      } else {
        // ObjNotificaciones.MSG_SUCCESS("success", "Participante modificado correctamente");
        return navigate("/Usuario/seleccionarCategoria");
        // return navigate("/Usuario/Agregarurl");
      }
    }

    let datanew = await apiParticipantes.crearParticipante(
      user.documento,
      infoparticipante
    );
    dispatch(
      guardarDatosPostulacion({
        ...participante.datos_postulacion,
        infoparticipante,
      })
    );

    if (guardar) {
      await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
      ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
      return navigate("/Usuario");
    } else {
      // ObjNotificaciones.MSG_SUCCESS("success", "Participante modificado correctamente");
      return navigate("/Usuario/seleccionarCategoria");
      // return navigate("/Usuario/Agregarurl");
    }
  };

  const guardarInformacionParticipanteGrupo = async (guardar?: boolean) => {
    const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));

    if (!infoparticipante.politicas)
      return openNotification({
        titulo: "Error",
        descripcion: "Falta aceptar las politicas de uso",
        placement: "bottomRight",
      });

    if (
      parseInt(moment(infoparticipante.fecha_nacimiento).format("YYYYMMDD")) >
      parseInt(moment().format("YYYYMMDD"))
    ) {
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha seleccionada es mayor a la actual",
        placement: "bottomRight",
      });
    }
    const user = getStorageUser()
    let { data } = await apiParticipantes.consultarParticipante(user.documento);
    if (!Array.isArray(data)) {
      let datamodif = await apiParticipantes.modificarParticipante(
        user.documento,
        infoparticipante
      );
      localStorage.setItem('id_participante_grupo_conformado', encrypt(data.id_participante.toString()));

      if (guardar) {
        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
        ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
        return navigate("/Usuario");
      } else {
        // ObjNotificaciones.MSG_SUCCESS("success", "Participante modificado correctamente");
        return navigate("/Usuario/agregarParticipante");
        // return navigate("/Usuario/Agregarurl");
      }
    }

    let datanew = await apiParticipantes.crearParticipante(
      user.documento,
      infoparticipante
    );

    if (guardar) {
      await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
      ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
      return navigate("/Usuario");
    } else {
      // ObjNotificaciones.MSG_SUCCESS("success", "Participante modificado correctamente");
      return navigate("/Usuario/agregarParticipante");
      // return navigate("/Usuario/Agregarurl");
    }
  };
  return {
    infoparticipante,
    setInforParticipante,
    cargarInformacionParticipante,
    guardarInformacionParticipante,
    guardarInformacionParticipanteGrupo,
    imageSelected,
    setImageSelected,
    loading,
  };
};
